module.exports = __webpack_public_path__ + "img/presidentialsweet_room_image03.d22c5fa6.jpg";